/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Helpful_Marmot_PinchInputs */

const fr_hour_helpful_marmot_pinch = /** @type {(inputs: Hour_Helpful_Marmot_PinchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes Records`)
};

/**

* @param {Hour_Helpful_Marmot_PinchInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_helpful_marmot_pinch = /** @type {((inputs?: Hour_Helpful_Marmot_PinchInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Helpful_Marmot_PinchInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_helpful_marmot_pinch(inputs)
});